<template>
  <div class="date-component" v-invalid="validation.is_valid">
    <div class="field" :class="getFieldClass(field.layout.layout_type)">
      <label class="label"
             v-if="field.label"
             :class="getLabelClass(field.layout.layout_type)"
             :for="field.id">
        <span>{{ field.label }}</span>
      </label>
      <div class="control has-icons-right" :class="getControlClass(field.layout.layout_type)">
        <flatpicker-component
          :value="formData.fields[field.id].value"
          :class="getInputClass(validation.is_valid)"
          :id="field.id"
          :name="field.id"
          :readonly="field.properties.input_readonly"
          :max="field.properties.max_value"
          :min="field.properties.min_value"
          :config="{ dateFormat: 'Y-m-d', static: false, allowInput: true }"
          @onDateSelected="onDateSelected">
        </flatpicker-component>
        <span class="icon is-medium-icon is-right">
          <i class="mdi mdi-calendar"></i>
        </span>
        <p class="help is-danger"
          v-if="!validation.is_valid">
          {{ validation.message }}
        </p>
        <p class="help"
          v-if="field.properties.help_text"
          v-html="field.properties.help_text">
        </p>
      </div>
    </div>

  </div>
</template>

<script>
  import FlatpickerComponent from '@/components/layout/utility/FlatpickerComponent'
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'
  import moment from 'moment'

  export default {
    name: 'date-component',
    components: {
      FlatpickerComponent
    },
    props: {
      field: {
        type: FormField
      },
      formData: {
        type: FormData
      }
    },
    computed: {
      validation () {
        return this.formData.validations[this.field.id] || { is_valid: true }
      }
    },
    methods: {
      onDateSelected (newDates) {
        this.formData.fields[this.field.id].value = moment(newDates[0]).format('YYYY-MM-DD')
        this.formData.inputOnChange(this.field)
      },
      getFieldClass: function (layoutType) {
        return {
          'columns is-multiline is-mobile': layoutType === 'horizontal'
        }
      },
      getLabelClass: function (layoutType) {
        return {
          'column is-4': layoutType === 'horizontal'
        }
      },
      getControlClass: function (layoutType) {
        return {
          'column is-8': layoutType === 'horizontal'
        }
      },
      getInputClass: function (isValid) {
        return {
          'is-danger': !isValid
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  label > li
    list-style-position: inside

</style>
